import { ReactNode } from 'react';
import { AppState } from 'globals/types';
import { connectWithViewport } from 'hermes-redux';
import ModalComp, {
  ModalProps,
} from 'wa-storybook/components/general/modal-portal-comp/modal-portal-comp';

type Props = ModalProps & {
  isKeyboardActive: boolean;
  preventInitialFocus?: boolean;
  children?: ReactNode;
};

const ModalPortalComp = (props: Props) => {
  const { preventInitialFocus, children, isKeyboardActive, ...modalProps } =
    props;

  return (
    <ModalComp
      {...modalProps}
      shouldInitialFocus={!preventInitialFocus && isKeyboardActive}
    >
      {children}
    </ModalComp>
  );
};

export default connectWithViewport(ModalPortalComp, (state: AppState) => ({
  isKeyboardActive: state.global.isKeyboardActive,
}));
